getFeaturedEpisodeUserNodeInfo